// Flatpickr global defaults: commit keyboard edits on blur/close, autocomplete off.
import flatpickr from "flatpickr";

let pressInCalendar = false;
const releasePress = () => {
  pressInCalendar = false;
};
document.addEventListener("pointerdown", (event) => {
  pressInCalendar = event.target instanceof Element
    && event.target.closest(".flatpickr-calendar") !== null;
}, true);
document.addEventListener("pointerup", releasePress, true);
// A press released outside the window sends no pointerup, which would leave the
// flag stuck and swallow the next keyboard edit.
window.addEventListener("blur", releasePress);

flatpickr.defaultConfig.onReady = [
  (_, __, instance) => {
    if (instance.input) instance.input.setAttribute("autocomplete", "off");
    if (instance.altInput) instance.altInput.setAttribute("autocomplete", "off");

    const target = instance.altInput || instance.input;
    if (!target) return;
    if (instance.calendarContainer) instance.calendarContainer._hermesInstance = instance;

    let edited = false;
    const commit = () => {
      edited = false;
      instance.setDate(instance.selectedDates, true);
    };
    target.addEventListener("input", (event) => {
      edited = event.isTrusted;
    });
    const close = instance.close;
    instance.close = () => {
      if (edited) commit();
      close.call(instance);
    };

    target.addEventListener("blur", () => {
      if (pressInCalendar || !edited) return;
      commit();
    });
  }
];

document.addEventListener("pointerdown", (event) => {
  const active = document.activeElement;
  if (!active || !active.classList.contains("numInput")) return;
  const calendar = active.closest(".flatpickr-calendar");
  if (!calendar || calendar.contains(event.target)) return;
  active.blur();
  const instance = calendar._hermesInstance;
  if (instance) instance.setDate(instance.selectedDates, true);
}, true);
